import { render, staticRenderFns } from "./LayoutsSection.vue?vue&type=template&id=6583d499"
import script from "./LayoutsSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsSection.vue?vue&type=style&index=0&id=6583d499&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports